import { createAction, props } from '@ngrx/store';

export enum EmployeesActions {
  EmployeesRequested = '[Employees] Employees Requested',
  EmployeesLoading = '[Employees] Employees Loading',
  EmployeesLoaded = '[Employees] Employees Loaded',
  EmployeesError = '[Employees] Employees Error',
}

export const EmployeesRequested = createAction(EmployeesActions.EmployeesRequested);
export const EmployeesLoading = createAction(EmployeesActions.EmployeesLoading);
export const EmployeesLoaded = createAction(EmployeesActions.EmployeesLoaded,
  props<{ employees: [] }>());
export const EmployeesError = createAction(EmployeesActions.EmployeesError);
